import React from "react";
import { useGov } from "@/hooks/governance";
import { ipfsToHttp } from "@/lib/format";
import { Badge, HashCell } from "@/components/primitives";
import { Table } from "@/components/Table";
import { GovPageShell, GovError, useGovNav } from "@/components/governance/GovShell";

export const ConstitutionHistory = ({ meta }) => {
  const { data, error, loading, refetch } = useGov("/governance/constitution/history");
  const rows = Array.isArray(data) ? data : [];
  const columns = [
    { key: "id", label: "Constitution", render: (r) => <span className="text-foreground">#{r.constitution_id}</span> },
    { key: "current", label: "Status", render: (r) => (r.current ? <Badge tone="success">current</Badge> : r.effective_from_epoch != null ? <Badge>historical</Badge> : <Badge>not enacted</Badge>) },
    { key: "from", label: "From", render: (r) => <span className="text-muted-foreground">{r.effective_from_epoch != null ? `epoch ${r.effective_from_epoch}` : "not enacted"}</span> },
    { key: "to", label: "To", render: (r) => <span className="text-muted-foreground">{r.current ? "current" : (r.effective_to_epoch ? `epoch ${r.effective_to_epoch}` : "—")}</span> },
    { key: "doc", label: "Document", align: "right", render: (r) => { const h = ipfsToHttp(r.anchor?.url); return h ? <a href={h} target="_blank" rel="noreferrer" className="text-primary hover:underline">doc ↗</a> : <span className="text-muted-foreground">—</span>; } },
    { key: "guard", label: "Guardrails", align: "right", render: (r) => <HashCell value={r.guardrail_script_hash} len={8} /> },
  ];
  return (
    <GovPageShell crumbs={meta.crumbs} title={meta.title} subtitle="All constitution versions over time.">
      {error ? <GovError error={error} onRetry={refetch} /> : <Table columns={columns} rows={rows} loading={loading} skeletonRows={4} empty="No constitution history." />}
    </GovPageShell>
  );
};
